import React, { useEffect } from "react";

// Extend the Window interface to include ebanqo_widget
declare global {
  interface Window {
    ebanqo_widget: any;
  }
}

const ChatButton = () => {
  //   // Dynamically load eBanqo script if not already loaded
  // useEffect(() => {
  //   const script = document.createElement("script");
  //   script.src = "https://widget.ebanqo.io/app.js";
  //   script.async = true;

  //   document.head.appendChild(script);

  //   return () => {
  //     document.head.removeChild(script);
  //   };
  // }, []);
  // Note: eBanqo script is already loaded in public/index.html
  // No need to load it again here - it's loaded globally

  const hideFloatingButton = () => {
    try {
      const floating_button = Array.from(
        document.getElementsByClassName(
          "ebanqo-wd-chat-button ebanqo-trigger-btn ebq-widget__bounce"
        )
      )[0] as HTMLElement | undefined;
      
      if (floating_button && floating_button.style) {
        floating_button.style.display = "none";
      }

      const initialMessage = document.querySelector(
        ".initial-prompt-message-wrapper .ebanqo-button-slide-left"
      ) as HTMLElement | null;
      
      if (initialMessage && initialMessage.style) {
        initialMessage.style.display = "none";
      }

      setTimeout(() => {
        const wrapper = document.querySelector(".initial-prompt-message-wrapper");
        if (wrapper) {
          wrapper.remove();
        }
      }, 100);
    } catch (error) {
      // Silently fail if elements don't exist yet
      console.debug("Could not hide floating button:", error);
    }
  };

  // Initialize eBanqo widget when called
  const initializeEbanqoWidget = () => {
    if (window.ebanqo_widget) {
      window.ebanqo_widget("init", {
        showChannelButtonsOnSignupForm: true,
        buttonColor: "#3B82F6",
        promptMessageDelay: 1000,
        promptMessage: "Hi there! How can I help you today?",
        instant_chat: {
          buttonColor: "#ED0D7F",
          logoUrl:
            "https://ebanqomessenger-public.s3.us-east-2.amazonaws.com/attachments/prod/webchat/poweredbymtnwhite.425023b05a934ab3aed1.png",
          url: "https://webchat.ebanqo.io/Mcare/",
          title: "Chat with Us",
          logoWidth: 80,
          logoHeight: 50,
          chatHeaderBackgroundColor: "#1a94ec",
          chatHeaderTextColor: "#fff",
        },
      });
    } else {
      console.error("eBanqo Widget not loaded");
    }
  };

  useEffect(() => {
    initializeEbanqoWidget();

    // Try to hide floating button after a delay to ensure DOM is ready
    const timer = setTimeout(() => {
      hideFloatingButton();
    }, 100);

    return () => {
      clearTimeout(timer);
    };
  }, []);

  return <div className=""></div>;
};

export default ChatButton;
